"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function HOC() {
  try {
    var handleSubmit = function handleSubmit(data) {
      dispatch((0, _functionalButton.createShop)(data));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    (0, _hoc.useMount)(function () {
      dispatch((0, _functionalButton.setInProcessAction)(false));
    });
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;